import { Avatar, Stack, Typography } from '@mui/material'
import SimpleCard from './SimpleCard'
import NumberFunctions from '../../core/functions/NumberFunctions'

interface DualCurrencyTotalsProps {
  info?: number
  infoUsd?: number
}

const DualCurrencyTotals = ({ info, infoUsd }: DualCurrencyTotalsProps) => {
  return (
    <>
      <SimpleCard sx={{ px: 4 }}>
        <Stack direction="row" spacing={2} alignItems="center">
          <Avatar sx={{ width: 40, height: 40, bgcolor: '#F2F2FF' }}>
            <img alt="Vendas" src="/assets/icons/payments/pay.svg" />
          </Avatar>
          <Stack direction="column">
            <Typography
              variant="body2"
              color="#707275"
              fontWeight={500}
              fontSize="14px"
              lineHeight="14px"
            >
              Valor líquido (R$)
            </Typography>
            <Typography
              variant="h4"
              color="#38393B"
              fontWeight={600}
              fontSize="24px"
              lineHeight="32px"
            >
              {NumberFunctions.formatMoneyDefault(
                NumberFunctions.toNumber(info)
              )}
            </Typography>
          </Stack>
        </Stack>
      </SimpleCard>
      <SimpleCard sx={{ px: 4 }}>
        <Stack direction="row" spacing={2} alignItems="center">
          <Avatar sx={{ width: 40, height: 40, bgcolor: '#F2F2FF' }}>
            <img alt="Vendas" src="/assets/icons/payments/pay.svg" />
          </Avatar>
          <Stack direction="column">
            <Typography
              variant="body2"
              color="#707275"
              fontWeight={500}
              fontSize="14px"
              lineHeight="14px"
            >
              Valor líquido (US$)
            </Typography>
            <Typography
              variant="h4"
              color="#38393B"
              fontWeight={600}
              fontSize="24px"
              lineHeight="32px"
            >
              {NumberFunctions.formatMoneyDefault(
                NumberFunctions.toNumber(infoUsd),
                'usd'
              )}
            </Typography>
          </Stack>
        </Stack>
      </SimpleCard>
    </>
  )
}

export default DualCurrencyTotals
